import React, { ComponentProps } from 'react';
import { HeartFilledIcon } from '@/component-library';
import { LOT_THEME } from '../_Common/lot.common.styles';

export const HeartFilled: React.FC<ComponentProps<typeof HeartFilledIcon>> = ({
  ...props
}) => {
  const speed = '0.6s';
  return (
    <svg
      width={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={LOT_THEME.graysRed}
        stroke={LOT_THEME.graysRed}
        strokeWidth="0%"
        fillRule="evenodd"
        d="M19.906 5.012C17.648 3.113 14.16 3.398 12 5.598c-2.16-2.2-5.648-2.489-7.906-.586-2.938 2.472-2.508 6.504-.414 8.64l6.851 6.98a2.048 2.048 0 0 0 2.938.005l6.851-6.98c2.09-2.137 2.528-6.169-.414-8.645Z"
        clipRule="evenodd"
      >
        <animate
          begin="indefinite"
          attributeName="stroke-width"
          values={`0%;5%;0%`}
          dur={speed}
          fill="freeze"
        />
      </path>
    </svg>
  );
};
